import React, { Component } from 'react'
import { Row,Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'
import { getMenuListSelector } from '../../../selectors'

const menuDetails =  MENU_OPTIONS.filter((ele) => ele.key === 'OTHER_SERVICES')[0].children
const subMenuDetails = menuDetails.filter((ele) => ele.key === 'DOWNLOAD_CENTER')[0].children

export default function DownLoadCenter() {
  const history = useHistory()
  const menuConfig = useSelector(getMenuListSelector)['OTHER_SERVICE_DOWNLOAD_CENTER'] || {}
  return (
      <LayoutWithOutAccountCard
       breadCumKey="DOWNLOAD_CENTER"
        keyPath={'DOWNLOAD_CENTER'}
        showEmptySpace={true}>
        <Row>
        {Object.keys(menuConfig).length>0 && subMenuDetails.map((option, index) => (
          <>
            {menuConfig[option.key] &&
              <MenuCard
                handleMenuCallback={() => history.push(option.link)}
                icon={option.icon}
                name={option.title}
                description={option.desc}
                key={index}
              />
            }
          </>
        ))}
        </Row>
      </LayoutWithOutAccountCard>
  )
}
